import {
  BrowserRouter,
  Route,
  Routes,
  Navigate
} from 'react-router-dom';
import Login from './Pages/Auth/Login/Login';
import Homepage from './Pages/Homepage/Homepage';

// Admin Components
import AdminLogin from './Pages/Admin/Login/AdminLogin';
import AdminLayout from './Components/Admin/AdminLayout';
import AdminDashboard from './Pages/Admin/Dashboard/AdminDashboard';
import UserList from './Pages/Admin/Users/UserList';
import UserDetail from './Pages/Admin/Users/UserDetail';
import GroupRequestList from './Pages/Admin/GroupRequests/GroupRequestList';
import GroupList from './Pages/Admin/Groups/GroupList';
import GroupDetail from './Pages/Admin/Groups/GroupDetail';
import ReportList from './Pages/Admin/Reports/ReportList';
import ReportDetail from './Pages/Admin/Reports/ReportDetail';
import UserReports from './Pages/Admin/Reports/UserReports';
import CityManagement from './Pages/Admin/ETC/CityManagement';
import UniversityManagement from './Pages/Admin/ETC/UniversityManagement';
import AppConfig from './Pages/Admin/ETC/AppConfig';
import ProtectedRoute from './Components/ProtectedRoute';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path='/' element={<AdminLogin />} />

        {/* Admin Login (Public) */}
        <Route path='/admin/login' element={<AdminLogin />} />

        {/* Protected Admin Routes */}
        <Route
          path='/admin'
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path='dashboard' element={<AdminDashboard />} />
          <Route path='users' element={<UserList />} />
          <Route path='users/:userId' element={<UserDetail />} />
          <Route path='group-requests' element={<GroupRequestList />} />
          <Route path='groups' element={<GroupList />} />
          <Route path='groups/:chatId' element={<GroupDetail />} />
          <Route path='reports' element={<ReportList />} />
          <Route path='reports/:reportId' element={<ReportDetail />} />
          <Route path='reports/user/:userId' element={<UserReports />} />
          <Route path='cities' element={<CityManagement />} />
          <Route path='universities' element={<UniversityManagement />} />
          <Route path='app-config' element={<AppConfig />} />
        </Route>

        {/* Catch all - redirect to admin login */}
        <Route path='*' element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </BrowserRouter>
  )
}